import { render } from "./BillingFormInitializer.vue?vue&type=template&id=60b88eac"
import script from "./BillingFormInitializer.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingFormInitializer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/BillingFormInitializer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60b88eac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60b88eac', __exports__)) {
    api.reload('60b88eac', __exports__)
  }
  
  module.hot.accept("./BillingFormInitializer.vue?vue&type=template&id=60b88eac", () => {
    api.rerender('60b88eac', render)
  })

}


export default __exports__